/**
 * TODO: validate that these are appropriate lineHeights to use based on some sort of standard
 */

export const lineHeights = {
  solid: 1,
  title: 1.25,
  copy: 1.5,
};
